export default __webpack_public_path__ + "static/media/11.efc797f7.png";